import { client } from "utils";

export const getValidatorsObjectPropertiesRequest = () => client.get("validators-for-object-properties");
